import React, { useState, useEffect } from "react";
import PageHead from "../Head";
import ContactUs from "@/components/ContactUs/ContactUs";
import Context from "@/context/Context";
import Header from "@/components/Header/Header";
import Head from "next/head";
import Image from "next/image";
import Address from "@/components/ContactUs/Address";
import Footer from "@/components/Footer/Footer";
import Copyright from "@/components/Footer/Copyright";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";
import CoverImg from "../../public/images/bg/contactus-cover.jpg";
import emailjs from "@emailjs/browser";
import MapContainer from "@/components/ContactUs/Map";
import MapboxComponent from "@/components/ContactUs/MapboxComponent";
import axios from "axios";
import { URL, URL_SERVER } from "@/constants";
import CallToAction from "@/components/CallToAction/CallToAction";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    emailjs.init({
      publicKey: "DRHGAsg5f23OvK3dc",
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    // console.log(formData);

    const requestBody = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      message: formData.message,
    };
    try {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.baseURL = URL_SERVER;
      const response = await axios.post(
        ///////// with backend api
        URL.EMAIL_API,
        requestBody
      );
      // console.log(response);
      if (response.status === 200) {
        if (response.data.data) {
          setIsLoading(false);
          alert("Your enquire is successfully sent.");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            message: "",
          });
        }
      }
    } catch (error) {
      console.error("Email sent error: ", error);
    }
  };

  return (
    <>
      <PageHead title="Contact Us" description={""} />
      <main className="page-wrapper">
        <Context>
          <Header btnClass="btn-small round" />
          <PopupMobileMenu />
          <div className="cover-section">
            <div className="container">
              <h1 className="title">Contact Us</h1>
            </div>
            <div className="image-wrapper">
              <Image src={CoverImg} alt="contact-cover" height={600} />
            </div>
          </div>
          <ContactUs
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            formData={formData}
          />
          {/* <MapContainer /> */}
          <MapboxComponent />
          <Address />
          <CallToAction />
          <Footer />
          <Copyright />
        </Context>
      </main>
    </>
  );
};

export default ContactUsPage;
